import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import hypercarMain from "@/assets/gallery/hypercar-main.jpg";
const About = () => {
  return <section className="py-24 bg-background">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }}>
            <p className="text-primary text-sm uppercase tracking-[0.3em] mb-4">About Us</p>
            <h2 className="section-heading mb-6">GENERATIONS OF EXCELLENCE</h2>
            <div className="space-y-4 text-muted-foreground">
              <p>
                Hyper Haus is a family-owned automotive customization shop in Los Angeles with over 40 years of hands-on experience. We are proud to be some of the original pioneers in the film business, passing down our knowledge to the next generation who continue to elevate our industry.
              </p>
              <p>
                Our clientele includes some of the biggest names in entertainment—Snoop Dogg and his label, LaMelo Ball, Brad Pitt—as well as direct partnerships with dealerships like Pagani Beverly Hills and Ancillary Studio.
              </p>
              <p>When you bring your vehicle to Hyper Haus, you're not just getting a service—you're getting hyper car craftsmanship from decades of refined expertise and a commitment to perfection that lesser shops simply cannot match.</p>
            </div>
            <Link to="/about" className="inline-flex items-center gap-2 mt-8 text-primary hover:gap-3 transition-all">
              Learn More About Us <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative">
            <div className="aspect-[4/5] rounded-lg overflow-hidden">
              <img alt="Hyper Haus new Hawthorne headquarters — state-of-the-art automotive protection facility" loading="lazy" width={596} height={794} className="w-full h-full object-cover" src="/lovable-uploads/7132a0d4-5a66-495b-8dd3-506b1417d51f.jpg" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-card border border-border rounded-lg p-6 max-w-xs">
              <p className="text-3xl font-display text-primary mb-1">40+</p>
              <p className="text-sm text-muted-foreground">Years of excellence in automotive protection and customization</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default About;